import { createFileRoute } from '@tanstack/react-router'

import { getEvalExpressionOptions } from '@/api/codegen/@tanstack/react-query.gen'
import { ValidationRuleEditPage } from '@/pages/taxonomy/ValidationRuleEdit.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules/$ruleId',
)({
  component: ValidationRuleEditPage,
  loader: ({ context: { queryClient }, params: { spaceId, ruleId } }) => {
    queryClient.ensureQueryData(
      getEvalExpressionOptions({
        path: {
          spaceID: spaceId,
          evalExpressionID: Number(ruleId),
        },
      }),
    )

    return { breadcrumbTitle: 'Edit validation rule' }
  },
})
